export default {"src":"/_next/static/media/kawasaki.82f70c64.svg","height":18,"width":160,"blurWidth":0,"blurHeight":0};